import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";

export default function Root() {
  const location = useLocation();

  // @TODO: there must be a better way
  const useContainer = !location.pathname.match(/^\/locations\/[^/]+\/units\/?$/);
  const containerElement = useRef<HTMLDivElement>(null);

  //   const scrollingTop = () => {
  //     scroll({ top: 150, behavior: "smooth" });
  //   };

  useEffect(() => {
    // scrollingTop();
  }, [location.pathname]);

  return (
    <div ref={containerElement}>
      {useContainer ? (
        <Container style={{ backgroundColor: "#fff", position: "relative" }}>
          <Outlet />
        </Container>
      ) : (
        <Outlet />
      )}
    </div>
  );
}
